// extracted by mini-css-extract-plugin
export default {"infoBanner":"InfoBanner_infoBanner__rmMYF","yellow":"InfoBanner_yellow__k0fiN","closeBanner":"InfoBanner_closeBanner__cg4iH","content":"InfoBanner_content__k2gPK"};